import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        statistics: [],
        loadingStats: false
    },
    getters: {
        
    },
    mutations: {
        
    },
    actions: {
        async findStatistics(store){
            store.state.loadingStats = true
            await this._vm.$axios.get(`/Cashier/Home/FindStatistics`)
            .then(response => {
                store.state.statistics = Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loadingStats = false
        },
    }
}